import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CustomerModel } from '../../models/customer.model';
import { Store } from '@ngrx/store';
import * as fromApp from '../../store/app.reducer';
import * as AuthActions from '../../auth/store/auth.actions';
import { Router } from '@angular/router';
import { SubscribeService } from 'src/app/services/subscribe.service';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-mobile-sidenav-content',
    templateUrl: './mobile-sidenav-content.component.html',
    styleUrls: ['./mobile-sidenav-content.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule, ReactiveFormsModule]
})
export class MobileSidenavContentComponent implements OnInit {
    public switchAccountOptions: boolean = true;
    public customers: CustomerModel[];
    public filteredCustomers: CustomerModel[];
     public searchForm: UntypedFormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private store: Store<fromApp.AppState>,
        public router: Router,
        private subscriberService: SubscribeService,
         private formBuilder: UntypedFormBuilder,
    ) {
       this.searchForm = this.formBuilder.group({
            searchCustomer: ['']
        });
    }

    ngOnInit(): void {
        this.store.select(state => state.auth).subscribe(authState => {
            this.customers = authState.employee.customers;
            this.filteredCustomers = this.customers;
        });
        
  // Subscribe to search form changes
        this.searchForm.get('searchCustomer').valueChanges.subscribe(value => {
            this.filterCustomers(value);
        });

    }

    isCurrentCompany(customer: CustomerModel): boolean {
        return this.data.customer?.id === customer?.id;
    }

   // Helper method to filter customers based on search input
    private filterCustomers(searchValue: string): void {
        if (!searchValue) {
            this.filteredCustomers = this.customers;
            return;
        }

        searchValue = searchValue.toLowerCase();
        this.filteredCustomers = this.customers?.filter(customer =>
            customer.companyName.toLowerCase().includes(searchValue)
        );
    }
    
    onSwitchCustomer(customer: CustomerModel, event?: Event) {
  event?.stopPropagation(); // prevent triggering clickOutside accidentally

  if (this.isCurrentCompany(customer)) {
    return;
  }

  // ✅ Close dropdown immediately
  this.switchAccountOptions = false;

  // Save selected customer
  localStorage.setItem('customer', customer.id.toString());

  // Switch in store
  this.store.dispatch(new AuthActions.SwitchCompanyAccount({ customer }));

  // Close sidebar
  this.subscriberService.closeSidebar();

  const assignmentsUrl = '/components/assignments';

  if (this.router.url === assignmentsUrl) {
    // Already on assignments page, reload data
    this.subscriberService.loadPage(true);
  } else {
    // Navigate normally
    this.router.navigate([assignmentsUrl]);
  }
}
clearSearch() {
  // Clear input
  this.searchForm.get('searchCustomer')?.setValue('');

  // Reset list to full
  this.filteredCustomers = [...this.customers];
}


} 